import { useEffect } from "react"
import parse from "html-react-parser"

import Modal from "shared/components/modal"
import PaymentInfoForm from "app/components/subscriptions/payment_info_form"
import closeX from "images/components/x.svg?raw"
import { CREDITS_CHECKOUT_PLAN_KEYS, CreditsTier, tierDisplayName } from "shared/utils/tiers"

import { CreditsCheckoutData } from "./api"
import PlanSummary, { PlanLogo } from "./plan_summary"

import styles from "./checkout_modal.module.scss"

interface Props {
  checkout: CreditsCheckoutData
  onClose: () => void
  onUpgraded: () => void
  visible: boolean
}

const CreditsCheckoutModal = ({ checkout, onClose, onUpgraded, visible }: Props) => {
  const { plan } = checkout
  const planName = tierDisplayName(plan.tier)

  useEffect(() => {
    if (visible) {
      window.App.Utils?.logCustomDatadogAction?.("stripe_checkout_initial")
      window.App.Utils?.logCustomDatadogAction?.("stripe_checkout_initial_modal")
    }
  }, [visible])

  return (
    <div className={`${styles["credits-checkout-modal"]} checkout-on-modal`}>
      <Modal show={visible} includeCloseX={false}>
        <div className={styles["checkout-container"]}>
          <aside className={styles["left"]} data-plan={CREDITS_CHECKOUT_PLAN_KEYS[plan.tier as CreditsTier]}>
            <PlanSummary tier={plan.tier} creditsPerMonth={plan.credits_per_month} features={plan.features} />
          </aside>

          <section className={styles["right"]}>
            <header className={styles["header"]}>
              <PlanLogo tier={plan.tier} className={styles["mobile-logo"]} />
              <button type="button" className={styles["close"]} aria-label="Close" onClick={onClose}>
                {parse(closeX)}
              </button>
            </header>
            <h2 className={styles["title"]}>Get more credits, run more Applets</h2>

            <PaymentInfoForm
              creditsCheckout
              ctaCopy={`Upgrade to ${planName}`}
              currencies={checkout.currencies}
              currencyPlans={plan.currency_plans}
              defaultCurrency={checkout.default_currency}
              eligibleForTrial={false}
              email={checkout.email}
              initialPromoCode={null}
              modalButtonType="new"
              onModalHandleSuccessfulSubscription={() => {
                window.appendFlash(`Upgrade complete. Welcome to IFTTT ${planName}!`, "success")
                onUpgraded()
                onClose()
              }}
              planId={plan.plan_id}
              productId={plan.product_id}
              redirectToMobileAppOnSuccess={false}
              referrerPath={window.location.href}
              renderingInsideModal={true}
              setupIntentClientSecret={checkout.setup_intent_client_secret}
              setupIntentReturnUrl={checkout.setup_intent_return_url}
              showCurrencySwitcher={checkout.show_currency_switcher}
              stripeCustomerPreinitialized={checkout.stripe_customer_preinitialized === true}
              tier={plan.tier}
              urls={{
                createStripeCustomerUrl: checkout.create_stripe_customer_url,
                subscriptionsPath: checkout.subscriptions_path,
                subscriptionSuccessPath: "",
              }}
            />
          </section>
        </div>
      </Modal>
    </div>
  )
}

export default CreditsCheckoutModal
